import { useCallback } from 'react';
import { FormContentIsland } from '@razz-team/ui-web';
import { Route } from '../../../routes/account.transactions';
import { TransactionSearchAutocomplete } from './TransactionSearchAutocomplete';

export function TransactionsFilters() {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  const handleSearchChange = useCallback(
    (nextSearch: typeof search) => {
      navigate({
        search: (prev) => ({
          ...nextSearch,
          until: prev.until,
          since: prev.since,
        }),
      });
    },
    [navigate],
  );

  return (
    <FormContentIsland slotProps={{ stack: { direction: { xs: 'column', sm: 'row' } } }}>
      <TransactionSearchAutocomplete value={search} onChange={handleSearchChange} />
    </FormContentIsland>
  );
}
